import React, { useState } from 'react';
import { X, ShieldCheck } from 'lucide-react';

// The checkbox is intentionally NOT pre-checked — acknowledgement must be
// an explicit, deliberate action to be legally meaningful.
const AckConfirmationDialog = ({ open, policyTitle, onConfirm, onClose, isSubmitting }) => {
  const [checked, setChecked] = useState(false);

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-2">
            <ShieldCheck className="h-5 w-5 text-green-600" />
            <h3 className="text-lg font-semibold text-gray-900">Acknowledge Document</h3>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="h-5 w-5" />
          </button>
        </div>

        <p className="text-sm text-gray-600 mb-4">
          You are about to acknowledge <span className="font-medium text-gray-900">"{policyTitle}"</span>.
          This action is recorded with your identity, timestamp, and cannot be undone.
        </p>

        <label className="flex items-start gap-2 text-sm text-gray-700 mb-6 cursor-pointer">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            className="mt-0.5"
          />
          I confirm that I have read and understood this document, and I accept it.
        </label>

        <div className="flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 text-sm">
            Cancel
          </button>
          <button
            onClick={() => onConfirm()}
            disabled={!checked || isSubmitting}
            className="px-4 py-2 rounded-lg bg-primary text-white text-sm disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? 'Submitting...' : 'I Accept'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AckConfirmationDialog;
